"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popper = void 0;
var react_1 = __importStar(require("react"));
var react_popper_1 = require("react-popper");
var utilities_1 = require("../../utilities");
var __1 = require("../");
var dedupe_1 = __importDefault(require("classnames/dedupe"));
var hooks_1 = require("../../hooks");
var framer_motion_1 = require("framer-motion");
exports.Popper = react_1.default.forwardRef(function (_a, ref) {
    var _b = _a.autoFlipHorizontally, autoFlipHorizontally = _b === void 0 ? false : _b, _c = _a.autoFlipVertically, autoFlipVertically = _c === void 0 ? false : _c, _d = _a.el, PopperElement = _d === void 0 ? 'div' : _d, _e = _a.width, width = _e === void 0 ? 'auto' : _e, _f = _a.direction, direction = _f === void 0 ? 't' : _f, _g = _a.portal, portal = _g === void 0 ? false : _g, children = _a.children, className = _a.className, onClickOutside = _a.onClickOutside, open = _a.open, _h = _a.style, style = _h === void 0 ? {} : _h, trigger = _a.trigger, bodyClassName = _a.bodyClassName, overlayContext = _a.overlayContext, _j = _a.caret, caret = _j === void 0 ? { show: false } : _j, animation = _a.animation, _k = _a.offset, offset = _k === void 0 ? { skidding: 0, distance: 0 } : _k, props = __rest(_a, ["autoFlipHorizontally", "autoFlipVertically", "el", "width", "direction", "portal", "children", "className", "onClickOutside", "open", "style", "trigger", "bodyClassName", "overlayContext", "caret", "animation", "offset"]);
    var _l = react_1.default.useState(null), referenceElement = _l[0], setReferenceElement = _l[1];
    var _m = react_1.default.useState(null), popperElement = _m[0], setPopperElement = _m[1];
    var localRef = react_1.default.useRef(null);
    var popperRef = hooks_1.useMergedRef(ref, localRef);
    var _o = react_1.default.useState(null), arrowElement = _o[0], setArrowElement = _o[1];
    var overlay = react_1.useContext(utilities_1.OverlayContext);
    var widthObserver = react_1.default.useMemo(function () { return ({
        name: 'widthObserver',
        enabled: width !== '100',
        phase: 'beforeWrite',
        requires: ['computeStyles'],
        fn: function (_a) {
            var state = _a.state;
            if (typeof width === 'string') {
                state.styles.popper.width = width + "px";
            }
            state.styles.popper.width = width;
        },
        effect: function (_a) {
            var instance = _a.instance;
            instance.forceUpdate();
        },
    }); }, [width]);
    var sameWidth = react_1.default.useMemo(function () { return ({
        name: 'sameWidth',
        enabled: width === '100',
        phase: 'beforeWrite',
        requires: ['computeStyles'],
        fn: function (_a) {
            var state = _a.state;
            state.styles.popper.width = state.rects.reference.width + "px";
        },
        effect: function (_a) {
            var state = _a.state;
            state.elements.popper.style.width = state.elements.reference.offsetWidth + "px";
        },
    }); }, [width]);
    var centerPlacement = react_1.default.useMemo(function () { return ({
        name: 'offset',
        enabled: true,
        options: {
            offset: function (_a) {
                var _b, _c;
                var reference = _a.reference, popper = _a.popper;
                if (direction === 'c') {
                    var offsetY = -(reference.height / 2) + -(popper.height / 2);
                    return [0, offsetY];
                }
                if (caret.show) {
                    return [0, 8];
                }
                return [(_b = offset.skidding) !== null && _b !== void 0 ? _b : 0, (_c = offset.distance) !== null && _c !== void 0 ? _c : 4];
            },
        },
    }); }, [direction, caret.show, offset.skidding, offset.distance]);
    var directionMapping = function () {
        switch (direction) {
            case 't':
                return 'top';
            case 'tr':
                return 'top-start';
            case 'tl':
                return 'top-end';
            case 'r':
                return 'right';
            case 'rt':
                return 'right-end';
            case 'rb':
                return 'right-start';
            case 'b':
            case 'c':
                return 'bottom';
            case 'br':
                return 'bottom-start';
            case 'bl':
                return 'bottom-end';
            case 'l':
                return 'left';
            case 'lt':
                return 'left-end';
            case 'lb':
                return 'left-start';
            default:
                return 'bottom-end';
        }
    };
    var fallbackPlacements = function () {
        if (autoFlipHorizontally) {
            switch (direction) {
                case 'r':
                    return ['left'];
                case 'rb':
                    return ['left-start'];
                case 'rt':
                    return ['left-end'];
                case 'l':
                    return ['right'];
                case 'lb':
                    return ['right-start'];
                case 'lt':
                    return ['right-end'];
                default:
                    break;
            }
        }
        if (autoFlipVertically) {
            switch (direction) {
                case 't':
                    return ['bottom'];
                case 'tr':
                    return ['bottom-start'];
                case 'tl':
                    return ['bottom-end'];
                case 'b':
                    return ['top'];
                case 'br':
                    return ['top-start'];
                case 'bl':
                    return ['top-end'];
                default:
                    break;
            }
        }
        return [];
    };
    var _p = react_popper_1.usePopper(referenceElement, popperElement, {
        modifiers: [
            centerPlacement,
            widthObserver,
            sameWidth,
            {
                name: 'flip',
                enabled: (autoFlipHorizontally || autoFlipVertically) &&
                    direction !== 'c',
                options: {
                    fallbackPlacements: fallbackPlacements(),
                },
            },
            {
                name: 'arrow',
                enabled: caret.show,
                options: { element: arrowElement, padding: 8 },
            },
        ],
        placement: directionMapping(),
    }), styles = _p.styles, attributes = _p.attributes;
    react_1.default.useEffect(function () {
        function handleClickOutside(event) {
            var _a, _b;
            //  Target is not part of wrapper or element
            var target = (_b = (_a = event.composedPath) === null || _a === void 0 ? void 0 : _a.call(event)[0]) !== null && _b !== void 0 ? _b : event.target;
            if ((popperRef === null || popperRef === void 0 ? void 0 : popperRef.current.contains(target)) || (popperElement === null || popperElement === void 0 ? void 0 : popperElement.contains(target))) {
                return;
            }
            onClickOutside === null || onClickOutside === void 0 ? void 0 : onClickOutside();
        }
        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [popperElement, onClickOutside, popperRef]);
    var animations = __assign({ initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: {
            type: 'easeInOut',
            duration: 0.3,
        } }, animation);
    return (react_1.default.createElement(PopperElement, __assign({ ref: popperRef, className: dedupe_1.default(className), style: __assign({}, style) }, props),
        react_1.default.createElement("div", { style: {
                display: PopperElement === 'span' && 'inline-block',
            }, ref: setReferenceElement }, trigger),
        react_1.default.createElement(__1.Portal, { conditional: portal },
            react_1.default.createElement(utilities_1.OverlayContext.Provider, { value: overlayContext
                    ? overlay.concat(overlayContext)
                    : overlay }, open && (react_1.default.createElement("div", __assign({ ref: setPopperElement, className: "Popper", style: __assign(__assign({}, styles.popper), { zIndex: utilities_1.calculateZindex(overlay) + 1 }) }, attributes.popper),
                react_1.default.createElement(framer_motion_1.AnimatePresence, null,
                    react_1.default.createElement(framer_motion_1.motion.div, __assign({}, animations, { className: dedupe_1.default('Popper__body', bodyClassName) }),
                        children,
                        caret.show && (react_1.default.createElement("div", __assign({ ref: setArrowElement, className: dedupe_1.default('Popper__caret', caret.className), style: styles.arrow }, attributes.popper)))))))))));
});
//# sourceMappingURL=Popper.js.map